import { render, staticRenderFns } from "./HL7Table.vue?vue&type=template&id=5afa60c2&scoped=true&"
import script from "./HL7Table.vue?vue&type=script&lang=js&"
export * from "./HL7Table.vue?vue&type=script&lang=js&"
import style0 from "./HL7Table.vue?vue&type=style&index=0&id=5afa60c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa60c2",
  null
  
)

export default component.exports